import { ListItemText } from "@mui/material";
import { StyledSiniestralidad } from "../../../../../../styled/Siniestros";

const GestionesParticularesCard = ({ data }) => {

  return (
    <StyledSiniestralidad.List>
      <StyledSiniestralidad.ListItem key="cronico">
        <ListItemText
          primary="Crónico"
          secondary={data?.cronico ? data.cronico : "Sin Información"}
        />
      </StyledSiniestralidad.ListItem>
      <StyledSiniestralidad.ListItem key="recalificacion">
        <ListItemText
          primary="Recalificación"
          secondary={
            data?.recalificacion ? data.recalificacion : "Sin Información"
          }
        />
      </StyledSiniestralidad.ListItem>
      <StyledSiniestralidad.ListItem key="demandaJudicial">
        <ListItemText
          primary="Demanda judicial"
          secondary={
            data?.demandaJudicial ? data.demandaJudicial : "Sin Información"
          }
        />
      </StyledSiniestralidad.ListItem>
      <StyledSiniestralidad.ListItem key="estado">
        <ListItemText
          primary="Estado"
          secondary={data?.estado ? data.estado : "Sin Información"}
        />
      </StyledSiniestralidad.ListItem>
    </StyledSiniestralidad.List>
  );
};

export default GestionesParticularesCard;
